import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.jobPageStore.bulkEditMode)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
          type: "checkbox",
          class: "checkbox-inline"
        }, null, 512), [
          [_vModelCheckbox, _ctx.selected]
        ])
      ]))
    : _createCommentVNode("", true)
}